import { LoadingCountdown } from "@package/ui-components";
import { get } from "lodash";
import { useCallback, useMemo } from "react";
import { useTriviaContext } from "../context-trivia";
import { TriviaButton } from "../TriviaButton/TriviaButton";
import { TriviaAnswerChart } from "./TriviaAnswerChart";

export function TriviaAnswer() {
  const { screen, questionIndex, questionChoiceIndexes, updateTriviaState } =
    useTriviaContext();

  const primaryColorText = useMemo<string>(
    () => get(screen, "flyout.post.customData.primaryColorText"),
    [screen],
  );
  const questions = useMemo<string[]>(() => {
    const q = get(screen, `flyout.post.customData.trivia.questions`, []);

    return Array.isArray(q) ? q : [];
  }, [screen]);
  const question = useMemo<string>(() => {
    const q = get(
      screen,
      `flyout.post.customData.trivia.questions[${questionIndex}].question`,
      "No Question",
    );

    return typeof q === "string" ? q.toUpperCase() : "No Question";
  }, [screen, questionIndex]);
  const correct = useMemo<boolean>(
    () =>
      !!get(
        screen,
        `flyout.post.customData.trivia.questions[${questionIndex}].answers[${questionChoiceIndexes[questionIndex]}].correct`,
        false,
      ),
    [screen, questionChoiceIndexes, questionIndex],
  );

  const proceed = useCallback(() => {
    updateTriviaState((draft) => {
      draft.questionIndex++;
      draft.component =
        draft.questionIndex >= questions.length ? "result" : "question";
    });
  }, [questions.length, updateTriviaState]);

  return (
    <div className="flex flex-col h-full w-full">
      <div className="h-3/4 w-full justify-start items-start">
        <div className="h-2/5 w-full flex justify-start items-start">
          <div className="flex flex-col h-full w-full justify-start items-center">
            <div className="flex grow text-4xl justify-center items-center text-center font-bold mt-8 px-8">
              {question}
            </div>
            <div className="flex-none w-full h-48 text-center">
              <LoadingCountdown
                total={5}
                fontSize={28}
                color={primaryColorText}
                onEnd={proceed}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col h-3/5 w-full pt-8 justify-center items-center">
          <div className="flex grow w-full pl-16 pr-20">
            <TriviaAnswerChart />
          </div>
          <div className=" flex w-full justify-center items-center">
            <div
              className="relative text-5xl px-12 py-8 mt-16 rounded-full"
              style={{
                backgroundColor: correct ? "#007d00" : "#a70000",
                color: "#ffffff",
              }}
            >
              {correct ? "Correct" : "Incorrect"}
            </div>
          </div>
        </div>
      </div>
      <div className="flex h-1/4 justify-center items-center px-20">
        <TriviaButton
          text={
            questionIndex >= questions.length - 1 ? "Finish" : "Next Question"
          }
          onHandleMouse={proceed}
        />
      </div>
    </div>
  );
}
